var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.84625 12.8535L7.1998 13.207L7.90691 12.4999L7.55336 12.1464L4.4075 9.00051L12.7998 9.00051L13.2998 9.00051L13.2998 8.00051L12.7998 8.00051L4.40632 8.00051L7.55336 4.85348L7.90691 4.49993L7.1998 3.79282L6.84625 4.14637L2.84625 8.14637C2.65099 8.34163 2.65099 8.65822 2.84625 8.85348L6.84625 12.8535Z","fill":"#041C1B"}));
}

ArrowBack.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
